import { Filter } from '@fabric-ui/components';
import {
  BarCategoryWidgetTypes,
  BarLegendPosition,
  BarSubType,
  DisplayModeOptions,
  PieBasicLegendPosition,
  PieCategoryWidgetTypes,
  PieLegendStyles,
  PieSubType,
  SortDir,
  WidgetCategory,
} from '../../CustomDashboards/types';

export const getPolicyViolationsByPolicyName = ({
  filter,
  isSmallScreen,
  size = 2,
  groupOthers = true,
}: {
  filter: Filter;
  isSmallScreen: boolean;
  size?: number;
  groupOthers?: boolean;
}): PieCategoryWidgetTypes => ({
  id: '',
  definition: {
    title: {
      title: 'Policy violations by policy name',
    },
    coords: {
      x: 0,
      y: 0,
      h: 3,
      w: 0,
    },
    custom: {
      showTotals: true,
      legend: {
        position: PieBasicLegendPosition.Top,
        style: PieLegendStyles.Table,
        showValues: !isSmallScreen,
        showPercentage: false,
      },
      fieldsPalette: {},
    },
  },
  category: WidgetCategory.Pie,
  type: PieSubType.Donut,
  requests: [
    {
      filter,
      select: {
        dims: [
          {
            name: 'policy_violation.policy_name',
          },
        ],
        metrics: [
          {
            name: 'total_policy_violations_granular',
            alias: 'total_policy_violations_granular',
          },
        ],
      },
      groupBy: ['policy_violation.policy_name'],
      sorting: [
        {
          name: 'total_policy_violations_granular',
          dir: SortDir.DESC,
        },
      ],
      top: {
        size,
        groupOthers,
      },
      projectionId: {
        name: 'uber_policy_violations',
        builtIn: true,
      },
      distinct: false,
    },
  ],
});

export const getPolicyViolationsByAssetType = ({
  filter,
  isSmallScreen,
  size = 2,
  groupOthers = true,
}: {
  filter: Filter;
  isSmallScreen: boolean;
  size?: number;
  groupOthers?: boolean;
}): PieCategoryWidgetTypes => ({
  id: '',
  definition: {
    title: {
      title: 'Policy violations by asset type',
    },
    coords: {
      x: 0,
      y: 0,
      h: 3,
      w: 0,
    },
    custom: {
      showTotals: true,
      legend: {
        position: PieBasicLegendPosition.Top,
        style: PieLegendStyles.Table,
        showValues: !isSmallScreen,
        showPercentage: false,
      },
      fieldsPalette: {},
    },
  },
  category: WidgetCategory.Pie,
  type: PieSubType.Donut,
  requests: [
    {
      filter,
      select: {
        dims: [
          {
            name: 'asset.type',
          },
        ],
        metrics: [
          {
            name: 'total_policy_violations_granular',
            alias: 'total_policy_violations_granular',
          },
        ],
      },
      groupBy: ['policy_violation.asset.type'],
      sorting: [
        {
          name: 'total_policy_violations_granular',
          dir: SortDir.DESC,
        },
      ],
      top: {
        size,
        groupOthers,
      },
      projectionId: {
        name: 'uber_policy_violations',
        builtIn: true,
      },
      distinct: false,
    },
  ],
});

export const getPolicyViolationsBySeverity = ({ filter }: { filter: Filter }): BarCategoryWidgetTypes => ({
  id: '',
  definition: {
    title: {
      title: 'Policy violations by severity',
    },
    coords: {
      x: 0,
      y: 0,
      h: 3,
      w: 0,
    },
    custom: {
      rowsColumnSwitch: false,
      legend: {
        position: BarLegendPosition.None,
        margin: { top: 20, bottom: 10 },
      },
      fieldsPalette: {},
      displayMode: DisplayModeOptions.FIT,
    },
  },
  category: WidgetCategory.Bar,
  type: BarSubType.BarVertical,
  requests: [
    {
      filter,
      select: {
        dims: [
          {
            name: 'policy_violation.severity',
          },
        ],
        metrics: [
          {
            name: 'total_policy_violations_granular',
            alias: 'total_policy_violations_granular',
          },
        ],
      },
      groupBy: ['policy_violation.severity'],
      sorting: [
        {
          name: 'total_policy_violations_granular',
          dir: SortDir.DESC,
        },
      ],
      top: {
        size: 5,
        groupOthers: false,
      },
      projectionId: {
        name: 'uber_policy_violations',
        builtIn: true,
      },
      distinct: false,
    },
  ],
});
